import styled from 'styled-components'
import { Box } from 'rebass'
import media from '../../../utils/style'

export const SearchHeroWrapper = styled(Box)`
  position: relative;
  z-index: 2;

  padding: 1px 16px 20px;

  width: 100%;
  margin-left: auto;
  margin-right: auto;
  background: url('https://media.auto.works/original/80af05623eaacd2e8462d376600d052c:5757fae3575e69e43046a82595bf40d2/hero-bg.jpg')
    ${(props) => props.theme.colors.blue};
  background-blend-mode: multiply;
  background-size: cover;
  background-position: center center;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${media.LargeScreenUp`
  height: 551px; 
  `}
`

export const SearchHeroWrapperInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${media.MediumScreenUp`
    padding: 20px 10px;
  `}

  ${media.LargeScreenUp`
    padding: 40px 20px;
  `}
`

export const SearchHeroHeading = styled.div`
  line-height: 1.4;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  color: #ffffff;
  text-align: center;
  padding: 20px 20px 10px;

  ${media.MediumScreenUp`
    font-size: 32px;
    padding-bottom: 30px;
  `}

  ${media.LargeScreenUp`
    font-size: 40px;
    padding: 50px 20px;
  `}

  a {
    color: inherit;
  }
`
